export default __webpack_public_path__ + "static/media/TXUI_Ramp_Corner_8x1.256.3f9852cb.png";